/* RZX Eyewear — assets/rzx-theme.js */
'use strict';

/* ── Announcement close ── */
const annClose = document.getElementById('rzxAnnClose');
const annBar   = document.getElementById('rzxAnn');
const header   = document.querySelector('.rzx-header');
if (annClose && annBar) {
  annClose.addEventListener('click', function () {
    annBar.style.display = 'none';
    if (header) header.classList.add('no-ann');
  });
}

/* ── Mobile menu ── */
const mobToggle = document.getElementById('rzxMobToggle');
const mobPanel  = document.getElementById('rzxMobPanel');
const mobBg     = document.getElementById('rzxMobBg');
const mobClose  = document.getElementById('rzxMobClose');
function openMob()  { if(mobPanel) mobPanel.classList.add('open'); if(mobBg) mobBg.classList.add('open'); if(mobToggle) mobToggle.setAttribute('aria-expanded','true'); }
function closeMob() { if(mobPanel) mobPanel.classList.remove('open'); if(mobBg) mobBg.classList.remove('open'); if(mobToggle) mobToggle.setAttribute('aria-expanded','false'); }
if (mobToggle) mobToggle.addEventListener('click', openMob);
if (mobClose)  mobClose.addEventListener('click', closeMob);
if (mobBg)     mobBg.addEventListener('click', closeMob);
document.querySelectorAll('#rzxMobPanel a, #rzxMobPanel button').forEach(function(el) {
  el.addEventListener('click', closeMob);
});

/* ── FAQ accordion ── */
document.querySelectorAll('.rzx-faq__q').forEach(function(btn) {
  btn.addEventListener('click', function () {
    var item   = btn.parentElement;
    var isOpen = item.classList.toggle('open');
    btn.setAttribute('aria-expanded', isOpen);
  });
});

/* ── Hero parallax ── */
var heroMotion = document.getElementById('rzxHeroMotion');
var heroImg    = document.getElementById('rzxHeroImg');
if (heroMotion && heroImg) {
  heroMotion.addEventListener('mousemove', function (e) {
    var r = heroMotion.getBoundingClientRect();
    var x = (e.clientX - r.left) / r.width  - .5;
    var y = (e.clientY - r.top)  / r.height - .5;
    heroImg.style.transform = 'rotateY(' + (x * 11) + 'deg) rotateX(' + (y * -9) + 'deg) translateZ(12px)';
  });
  heroMotion.addEventListener('mouseleave', function () {
    heroImg.style.transform = 'none';
  });
}

/* ── Scroll reveal ── */
var observer = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('in'); });
}, { threshold: 0.1 });
document.querySelectorAll('.rzx-reveal').forEach(function(el) { observer.observe(el); });

/* ── Cart count update (Dawn-compatible) ── */
document.addEventListener('cart:updated', function(e) {
  var badges = document.querySelectorAll('[data-rzx-cart-count]');
  badges.forEach(function(b) { b.textContent = e.detail && e.detail.cart ? e.detail.cart.item_count : ''; });
});
